module.exports = __webpack_public_path__ + "aec8c4fd67f331c9a8feac0deb778968.png";